import React from 'react';
import { Redirect } from 'react-router-dom';

const ShortUrlsControlpanelRedirect = () => <Redirect to="/short-urls" />;

export default ShortUrlsControlpanelRedirect;
